import {createFileRoute} from "@tanstack/react-router";
import {ReferralNew} from "@/components/profile/ReferralNew/ReferralNew.tsx";

export const Route = createFileRoute("/_mainLayout/profile/referral/")({
  component: ReferralNew,
});
